// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"652":"4d93d640","768":"be669339"}[chunkId] + ".css";
};